import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {

  public phonePattern = /^[0-9]*$/;
  // public emailPattern = EMAIL_PATTERN;
  // public letterPattern = /^[-\sa-zA-Z]+$/;
  // public letterPattern = /^[A-Za-z '-]*$/;
  public letterPattern = /^[^\s^\d]+(\s?[^\s^\d]+)*$/;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  handleBookerValidation(thisForm, data, bookingType?) {

    let hasError = false;
    const objData = JSON.parse(JSON.stringify(data));
    objData.firstName = data.firstName.trim();
    objData.lastName = data.lastName.trim();
    data = objData;

    if (data.firstName.length <= 1 || data.firstName === null) {
      thisForm.form.controls['bookerFirstName'].setErrors({'incorrect': true});
      hasError = true;
    } else if (!this.letterPattern.test(data.firstName)) {
      thisForm.form.controls['bookerFirstName'].setErrors({'pattern': true});
      hasError = true;
    }

    if (data.lastName.length <= 1 || data.lastName === null) {
      thisForm.form.controls['bookerLastName'].setErrors({'incorrect': true});
      hasError = true;
    } else if (!this.letterPattern.test(data.lastName)) {
      thisForm.form.controls['bookerLastName'].setErrors({'pattern': true});
      hasError = true;
    }

    if (data.countryCode === '') {
      thisForm.form.controls['contactPhone'].setErrors({'incorrect': true});
      hasError = true;
    }
    if (data.phoneNumber === '') {
      thisForm.form.controls['contactPhone'].setErrors({'incorrect': true});
      hasError = true;
    }

    if (data.emailAddress === '') {
      thisForm.form.controls['bookerEmail'].setErrors({'incorrect': true});
      hasError = true;
    }

    if(thisForm.form.controls.bookerEmailConfirm) {
      if (data.emailAddressConfirm === '') {
        thisForm.form.controls['bookerEmailConfirm']?.setErrors({'incorrect': true});
        hasError = true;
      }

      if(bookingType !== 'amend') {
        if (data.emailAddress !== data.emailAddressConfirm) {
          thisForm.form.controls['bookerEmailConfirm']?.setErrors({'incorrect': true});
          hasError = true;
        }
      }
    }

    if (hasError) {
      if (isPlatformBrowser(this.platformId)) {
        window.scroll(0, 0);
      }
    }

    return hasError;

  }

  markFormDirty(thisForm) {
    for (const i in thisForm.controls) {
      if (thisForm.controls[i]) {
        thisForm.controls[i].markAsDirty();
      }
    };

    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }
}
